export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-6675ea02541eacb2dc260625cb4ec1f0.woff";